/**
 * The mark is the peeking-cat asset, rendered at full frame — no cropping, no
 * zoom, no background-position tricks — so the cat reads identically at every
 * size, from the 20px favicon to the sign-in screen.
 *
 * The soft rounded card around it is chrome, not artwork: the asset has a white
 * background, and without a border it would bleed into a white sidebar.
 */
export function LogoMark({ size = 28, className = '' }) {
  return (
    <img
      src="/distrx-icon.gif"
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      draggable={false}
      className={`shrink-0 select-none ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: Math.max(6, Math.round(size / 3.5)),
        border: '1px solid rgb(var(--line))',
        background: '#ffffff',
        boxShadow: 'var(--shadow-xs)',
        objectFit: 'contain',
      }}
    />
  );
}

export function Logo({ compact = false, size = 28, className = '' }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} />
      {!compact && <span className="text-[17px] font-semibold tracking-tight text-ink">DistrxPay</span>}
    </div>
  );
}

export default Logo;
